import { render, staticRenderFns } from "./CodigoUnidadeConsumidoraField.vue?vue&type=template&id=17dc4cce&scoped=true&"
import script from "./CodigoUnidadeConsumidoraField.vue?vue&type=script&lang=js&"
export * from "./CodigoUnidadeConsumidoraField.vue?vue&type=script&lang=js&"
import style0 from "./CodigoUnidadeConsumidoraField.vue?vue&type=style&index=0&id=17dc4cce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dc4cce",
  null
  
)

export default component.exports